import { render } from "./KpsPersonnelView.vue?vue&type=template&id=12e303e8&scoped=true"
import script from "./KpsPersonnelView.vue?vue&type=script&lang=js"
export * from "./KpsPersonnelView.vue?vue&type=script&lang=js"

import "./KpsPersonnelView.vue?vue&type=style&index=0&id=12e303e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e303e8"]])

export default __exports__